import { useContext } from "react";
import { SmartContext } from "../../../library/Core/SmartContext";
import { getDomainValueForCode } from "../../../library/Core/SmartFunctions";

const GraduationInformation = (props: any) => {
    const { state } = useContext(SmartContext);

return(
    <div className="impact-flow-detail border-success p-3 p-sm-4">
            <div className="row g-2">
                <div className="col">
                    <h3 className="font-18 font-600">Graduation Information Collected</h3>
                    <div className="row g-2">
                        <div className="col-auto font-16 font-500"><i className="icon-tick d-inline-block me-1"></i> {state?.data?.selectedInstitute?.passOutYear}
                        </div>
                            <div className="col-auto font-16 font-500">
                            <i className="icon-tick d-inline-block me-1"></i>
                            {state?.data?.user?.userTypeCode==='ALUMNI' ? 'Completed' : 'Pursuing'}{' '}
                            {getDomainValueForCode(
                                state?.data?.selectedInstitute?.programId,
                                'ALL_PROGRAM_CODE',
                                state
                            )}{' '}
                            from{' '}
                            {getDomainValueForCode(
                                state?.data?.selectedInstitute?.instituteId,
                                'INSTITUTE_DOMAIN',
                                state
                            )}, {' '}
                            {getDomainValueForCode(
                                state?.data?.profile?.residingCityCode,
                                'CITY_CODE',
                                state
                            )}
                            </div>
                    </div>
                </div>
                <div className="col-auto">
                    <i className="bi bi-check-circle-fill fs-1 text-green"></i>
                </div>
            </div>
        </div>       
    )
};

export default GraduationInformation;